import "jspdf-autotable";
import { DateTime } from "luxon";
import { fetchEmployee } from "../../api/employee";
import { BID_TYPE, BID_AWARDED_TIME_OFF_TYPES } from "../../util/bid/bidConstants";
import { getDayOfTheWeek } from "../../util/bid/freedayBidUtils";
import { ADMIN_PDF_HEADER, EMPLOYEE_TEMP_LABEL } from "../../util/constants";
import { getStationTimeZoneDateTimeStringFromUTCInteger } from "../../util/timeZoneService";

export const generateFilenameForChoicesPDFExport = (bidChoiceData) => {
  const lastSubmittedDate = getStationTimeZoneDateTimeStringFromUTCInteger(
    Date.parse(bidChoiceData.createdAt),
    bidChoiceData.station
  ).toFormat("yyyy-MM-dd_HHmm");

  return `${bidChoiceData.bidType.replace(/[/\\:*?"<>|\s]/g, "_")}_Choices_${bidChoiceData.schedMonth.substr(0, 3)}_${
    bidChoiceData.schedYear
  }_${lastSubmittedDate}.pdf`;
};

export const fetchEmployeeData = async (eid, setExportLoading) => {
  return await fetchEmployee(eid)
    .then((res) => res.json())
    .then((result) => {
      if (!result.error && !result.message) {
        return result;
      } else {
        console.log("Invalid Employee ID");
        setExportLoading(false);
      }
    })
    .catch((err) => {
      console.error("error fetching employee data!", err);
      setExportLoading(false);
      return null;
    });
};

export const formatChoicesDataForPDF = (choices, bidType) => {
  const rows = [];
  if (bidType === BID_TYPE.TWU_DAT_FTO || bidType === BID_TYPE.NC_PTO_FTO || bidType === BID_TYPE.NC_PTO_GOC_HOL) {
    choices?.forEach((choice, i) => {
      rows.push({
        choice: i + 1,
        date: DateTime.fromISO(choice.date).toFormat("MM/dd     EEE"),
        timeOffType: choice.timeOffType,
      });
    });
  } else {
    choices?.forEach((choice, i) => {
      rows.push({
        choice: i + 1,
        date: DateTime.fromISO(choice).toFormat("MM/dd     EEE"),
      });
    });
  }

  return rows;
};

export const generateFilenameForAdminAwardPDFExport = ({
  station,
  workgroup,
  bidType,
  bidName,
  schedMonth,
  schedYear,
}) => {
  return `STARS_${station}_${workgroup.replace(/ /g, "_")}_${bidType.replace(/[/\\:*?"<>|\s]/g, "_")}${
    bidName ? `_${bidName.replace(/[/\\:*?"<>|\s]/g, "_")}` : ""
  }_Results_${schedMonth}_${schedYear}.pdf`;
};

export const generateFilenameForEmployeeAwardPDFExport = ({ station, workgroup, bidType, schedMonth, schedYear }) => {
  return `STARS_${station}_${workgroup.replace(/ /g, "_")}_${bidType.replace(
    /[/\\:*?"<>|\s]/g,
    "_"
  )}_Results_Emp_View_${schedMonth}_${schedYear}.pdf`;
};

const getMTOBidAwardedTimeOffType = (bidAllotment) => {
  return bidAllotment.awardedDays
    ? bidAllotment.awardedDays?.find((awardedDay) => awardedDay.date === bidAllotment.date).timeOffType
    : "-";
};

export const formatDataForAwardPDF = (bidAllotments, pdfType) => {
  let formattedBidAllotments = [];
  for (const bidAllotment of bidAllotments) {
    let formattedBidAllotment = {};
    formattedBidAllotment["date"] = `${DateTime.fromFormat(bidAllotment.date, "yyyy-MM-dd").toFormat(
      "MM/dd"
    )} ${getDayOfTheWeek(bidAllotment.date)}`;

    formattedBidAllotment["awardedTimeOffType"] =
      bidAllotment.awardedTimeOffType === BID_AWARDED_TIME_OFF_TYPES.TWU_DAT_FTO ||
      bidAllotment.awardedTimeOffType === BID_AWARDED_TIME_OFF_TYPES.PTO_FTO ||
      bidAllotment.awardedTimeOffType === BID_AWARDED_TIME_OFF_TYPES.PTO_GOC_HOL
        ? getMTOBidAwardedTimeOffType(bidAllotment)
        : bidAllotment.awardedTimeOffType;

    formattedBidAllotment["eid"] = bidAllotment.eid;
    formattedBidAllotment["name"] =
      bidAllotment.lastName && bidAllotment.firstName
        ? bidAllotment.isTemp
          ? `${bidAllotment.lastName}, ${bidAllotment.firstName} (${EMPLOYEE_TEMP_LABEL})`
          : `${bidAllotment.lastName}, ${bidAllotment.firstName}`
        : "";
    if (pdfType === ADMIN_PDF_HEADER) {
      formattedBidAllotment["awardedRank"] = bidAllotment.awardedRank;
      formattedBidAllotment["awardType"] = bidAllotment.awardType;
    }
    formattedBidAllotment["allotment"] = bidAllotment.awardedAllotment;
    formattedBidAllotment["standardRelief"] = bidAllotment.standardRelief;
    formattedBidAllotments.push(formattedBidAllotment);
  }
  return formattedBidAllotments;
};
